import { useOnboardingPaymentMethods } from "ui/organizms/ECommerce/Onboarding/common";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingApplication } from "../../hooks";

export const usePaymentMethods = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const {
        paymentMethods,
        getPaymentMethods,
        fromPaymentMethodsInitialValues,
        toRequestPaymentMethods,
        withValues,
        ...data
    } = useOnboardingPaymentMethods({
        getApplicationModel
    });

    const formProps: HighRiskMerchant.PaymentMethods.OnboardingPaymentMethodsForm = {
        isBootstrapDataLoading: false,
        bootstrapData: {
            methods: getPaymentMethods()
        },
        initialValues: HighRiskMerchant.PaymentMethods.getInitialValues(
            fromPaymentMethodsInitialValues(data)
        ),
        onSaveOrCreate: async ({
            otherMethods,
            methods = []
        }, helpers) => (
            withValues({
                otherMethods,
                methods: toRequestPaymentMethods(methods)
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...HighRiskMerchant.PaymentMethods.useForm(formProps),
        ...data
    };
};

export default usePaymentMethods;
